import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type IconName =
  | 'home'
  | 'package'
  | 'repeat'
  | 'log-out'
  | 'menu'
  | 'x'
  | 'chevron-right'
  | 'external-link'
  | 'plus'
  | 'lock';

@Component({
  selector: 'mng-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'mng-icon' },
})
export class MngIconComponent {
  readonly name = input.required<IconName>();
}
